/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { auth_ParentMeChildDTO } from './auth_ParentMeChildDTO';
export type auth_ParentMeResponse = {
    avatarUrl?: string;
    children?: Array<auth_ParentMeChildDTO>;
    clerkUserId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    /**
     * MustChangePassword is true while the parent still signs in with the
     * one-time password the daycare issued (#1917). Always false while an admin
     * views the app as a parent.
     */
    mustChangePassword?: boolean;
    orgId?: string;
    userId?: string;
    userType?: auth_ParentMeResponse.userType;
};
export namespace auth_ParentMeResponse {
    export enum userType {
        PARENT = 'parent',
    }
}

